export default "__VITE_ASSET__DPhB_K78__"